<template>
  <div v-if="errors.length" class="alert alert-danger alert-dismissible">
    <span v-for="(error, i) in errors" :key="i">
      <hr v-if="i > 0"/>
      {{ error }}
    </span>
    <button @click="dismiss()" :title="'Dismiss ' + ((errors.length == 1) ? 'this error' : 'these errors')" class="btn-close"></button>
  </div>
</template>

<script>
  export default {
    name: "Errors",
    props: {
      errors: {type: Array}
    },
    methods: {
      dismiss() {
        this.$emit("dismiss");
      }
    }
  };
</script>
